/*
  饼干印章产品页的小脚本
  - 截单倒计时：按柏林时间算剩余天数，过了截单日整块隐藏
  - 「回到定制」按钮（href="#" 且带 data-lf-bx-top）：滚到 PatchStitch 定制框，没有就滚到商品信息
  - 常见问题：同一时间只展开一条
*/
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-lf-bx-deadline]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var c = el.getAttribute('data-cutoff'); if (!c) return;
      var days = Math.ceil((new Date(c + 'T23:59:00+01:00') - new Date()) / 864e5);
      if (isNaN(days)) return;
      if (days < 0) { el.hidden = true; return; }
      var d = el.querySelector('[data-lf-bx-days]'); if (d) d.textContent = days;
    });
    document.querySelectorAll('[data-lf-bx-top]:not([data-ready])').forEach(function (a) {
      a.setAttribute('data-ready', '');
      if (a.getAttribute('href') !== '#') return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.querySelector('[data-patchstitch-root]') || document.querySelector('.product-details');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-lf-bx-faq]:not([data-ready])').forEach(function (list) {
      list.setAttribute('data-ready', '');
      list.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        list.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
      /* 分类标签：只显示选中分类的问答 */
      var chips = list.querySelectorAll('.lf-bx-faq__cats [data-cat]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var cat = chip.getAttribute('data-cat');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
          list.querySelectorAll('.lf-bx-faq__item').forEach(function (d) {
            d.hidden = cat !== 'all' && d.getAttribute('data-cat') !== cat;
            if (d.hidden) d.open = false;
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
